module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stan Nicholls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Stan Nicholls is best known for the internationally acclaimed Orcs: First Blood series. His journalism has appeared in "), _c('I', [_vm._v("Locus, SFX,")]), _vm._v(" the "), _c('I', [_vm._v("Guardian")]), _vm._v(", the "), _c('I', [_vm._v("Independent")]), _vm._v(", the "), _c('I', [_vm._v("Daily Mirror")]), _vm._v(", "), _c('I', [_vm._v("Time Out")]), _vm._v(", "), _c('I', [_vm._v("Sight and Sound")]), _vm._v(", and "), _c('I', [_vm._v("Rolling Stone")]), _vm._v(", among many other publications. He currently lives in the West Midlands, U.K., with his wife, the writer Anne Gay.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/p1WmKa/tc-custom/9780061828133.jpg?1731214479744",
      "alt": "This image is the cover for the book Covenant Rising, The Dreamtime Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Covenant Rising, The Dreamtime Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a land where magic defines the social order, the ruling tyrants alone control the most powerful sorcery ...")]), _c('p', [_vm._v("One of the last of a massacred race of warriors -- an unparalleled swordsman magically afflicted by spells of blind, uncontrollable rage -- Reeth Caldason wanders Bhealfa seeking vengeance ... and freedom from his strange malady. Now word has come from a sorcerer's apprentice of a mysterious Covenant in the capital city, a secretive society that may provide the escape Reeth desires. But forming an uneasy alliance with the youthful messenger could ultimately prove disastrous -- for the road they musttravel together leads into the sordid heart of a perilous conspiracy of treachery, tyranny, necromancy, and death.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0